import { useMutation } from '@tanstack/react-query'
import { updateBatch } from '../../services'
import { BatchesMutationKeys } from '@/modules/batches/keys'
import { UpdateBatchRequest, UpdateBatchResponse } from '@/modules/batches/type'
import { UseBaseMutationOptions } from '@/core/api/type'

interface UpdateBatchParams {
	id: string
	request: UpdateBatchRequest
}

export default function useMutationUpdateBatch(
	props?: UseBaseMutationOptions<UpdateBatchResponse, UpdateBatchParams>,
) {
	return useMutation({
		mutationKey: [BatchesMutationKeys.UpdateBatch],
		mutationFn: ({ id, request }) => updateBatch(id, request),
		...props,
	})
}
